module.exports = __webpack_public_path__ + "media/images/lb/123-9252b541a82d8e113815fff59fec66b6.svg";